import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { browserHistory } from 'react-router';
// import Moment from 'react-moment';
// import Pagination from "react-js-pagination";
// import * as constant from '../../../../constants/constant';
// import * as adminDashboardActions from '../../../../actions/admin/dashboard/admindashboardActions.js';
import autoBind from 'auto-bind';
import * as SVGICONS from "../../../../images/img/images";
import * as specialistActions from '../../../../actions/specialistActions';
import { ToastContainer, toast } from 'react-toastify';

// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';
// import * as statisticsActions from '../../../../actions/statisticsActions';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
// import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
// import * as vettingUserActions from "../../../../actions/admin/vettinguser/vettingUserActions.js";
// import Switch from "react-switch";

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, BarChart, Legend, Label, ScatterChart, Scatter, Area, AreaChart } from 'recharts';
// import { isAbsolute } from 'path';
// import moment from 'moment';
// import $ from 'jquery';
// import '../../../../customScrollBar.js';
import {
    Button,
} from 'react-bootstrap';

import 'react-datepicker/dist/react-datepicker.css';
const errorFontSize = {
    fontSize: 11
}
// const { getCode } = require('country-list');
var getCountry = require('country-currency-map').getCountry;

class CurrencyDashboard extends React.Component {
    constructor(props, context) {
        super(props, context);
        autoBind(this);
        this.state = {
            countryList: [],
            country: { value: '', IsValied: true, message: '' },
            toRange1: { value: '', IsValied: true, message: '' },
            toRange2: { value: '', IsValied: true, message: '' },
            toRange3: { value: '', IsValied: true, message: '' },
            fromRange1: { value: '', IsValied: true, message: '' },
            fromRange2: { value: '', IsValied: true, message: '' },
            fromRange3: { value: '', IsValied: true, message: '' },
            countryAbbr: ''
        }

        this.onCountryChange = this.onCountryChange.bind(this)
        this.onChange = this.onChange.bind(this);
        this.resetAll = this.resetAll.bind(this);
    }



    // searchText
    componentWillMount() {
        this.props.actions.getCountriesList();
    }
    componentWillReceiveProps(nextProps) {

        var state = this.state
        state.countryList = nextProps.countryList && nextProps.countryList.length > 0 ? nextProps.countryList : state.countryList,
            state.currencyFilter = nextProps.currencyFilter ? nextProps.currencyFilter : [],
            state.listcurrencyFilter = nextProps.listcurrencyFilter ? nextProps.listcurrencyFilter[0] : [],
            state.toRange1.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV1 : '',
            state.fromRange1.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV2 : '',
            state.toRange2.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV3 : '',
            state.fromRange2.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV4 : '',
            state.toRange3.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV5 : '',
            state.fromRange3.value = nextProps.listcurrencyFilter && nextProps.listcurrencyFilter.length ? nextProps.listcurrencyFilter[0].rangeV6 : '',
            this.setState(state);
    }

    onChange(event) {
        var state = this.state;
        if (event.target.name == "toRange1") {

            if (event.target.value == "") {
                state.toRange1.isValid = false;
                state.toRange1.message = 'To Range is required';
                state.toRange1.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.toRange1.isValid = true;
                state.toRange1.message = '';
                state.toRange1.value = event.target.value;



                this.setState(state);
            }
        }
        else if (event.target.name == "toRange2") {

            if (event.target.value == "") {
                state.toRange2.isValid = false;
                state.toRange2.message = 'To Range is required';
                state.toRange2.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.toRange2.isValid = true;
                state.toRange2.message = '';
                state.toRange2.value = event.target.value;



                this.setState(state);
            }

        }
        else if (event.target.name == "toRange3") {

            if (event.target.value == "") {
                state.toRange3.isValid = false;
                state.toRange3.message = 'To Range is required';
                state.toRange3.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.toRange3.isValid = true;
                state.toRange3.message = '';
                state.toRange3.value = event.target.value;



                this.setState(state);
            }


        }
        else if (event.target.name == "fromRange1") {

            if (event.target.value == "") {
                state.fromRange1.isValid = false;
                state.fromRange1.message = 'From Range is required';
                state.fromRange1.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.fromRange1.isValid = true;
                state.fromRange1.message = '';
                state.fromRange1.value = event.target.value;



                this.setState(state);
            }
        }
        else if (event.target.name == "fromRange2") {

            if (event.target.value == "") {
                state.fromRange2.isValid = false;
                state.fromRange2.message = 'From Range is required';
                state.fromRange2.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.fromRange2.isValid = true;
                state.fromRange2.message = '';
                state.fromRange2.value = event.target.value;



                this.setState(state);
            }
        }
        else if (event.target.name == "fromRange3") {

            if (event.target.value == "") {
                state.fromRange3.isValid = false;
                state.fromRange3.message = 'From Range is required';
                state.fromRange3.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.fromRange3.isValid = true;
                state.fromRange3.message = '';
                state.fromRange3.value = event.target.value;



                this.setState(state);
            }
        }
        console.log(this.state.toRange1, )
        console.log(this.state.toRange2, )
        console.log(this.state.toRange3, )
        console.log(this.state.fromRange1, )
        console.log(this.state.fromRange2, )
        console.log(this.state.fromRange3, )
    }
    onCountryChange(event) {
        var state = this.state;
        if (event.target.name == "country") {

            if (event.target.value == "") {
                state.country.isValid = false;
                state.country.message = 'country is required';
                state.country.value = event.target.value;
                // state.tags = [];
                this.setState(state);
            }

            else {
                state.country.isValid = true;
                state.country.message = '';
                state.consultationErrMsg = '';

                state.country.value = event.target.value;



                this.setState(state);
            }
        }
        var countryId = this.state.country.value;
        var filterObj = this.state.countryList.filter(function (e) {
            return e._id == countryId
        });
        var countryname = filterObj[0].name;
        countryname = countryname.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');


        var countryAbbr = getCountry(countryname);
        this.setState({
            countryAbbr: countryAbbr.currency
        })
        let obj = {
            country: this.state.country.value
        }
        this.props.actions.listCurrencyFilter(obj)

    }
    componentDidMount() {


    }
    saveFlterData() {
        var state = this.state;


        if (this.state.toRange1 == "") {
            state.toRange1.isValid = false;
            state.toRange1.message = 'To Range is required';

            this.setState(state);
        }

        else {
            state.toRange1.isValid = true;
            state.toRange1.message = '';
            this.setState(state);
        }



        if (this.state.toRange2 == "") {
            state.toRange2.isValid = false;
            state.toRange2.message = 'To Range is required';
            this.setState(state);
        }

        else {
            state.toRange2.isValid = true;
            state.toRange2.message = '';
            this.setState(state);
        }



        if (this.state.toRange3 == "") {
            state.toRange3.isValid = false;
            state.toRange3.message = 'To Range is required';
            this.setState(state);
        }

        else {
            state.toRange3.isValid = true;
            state.toRange3.message = '';
            this.setState(state);
        }





        if (this.state.fromRange1 == "") {
            state.fromRange1.isValid = false;
            state.fromRange1.message = 'From Range is required';
            this.setState(state);
        }

        else {
            state.fromRange1.isValid = true;
            state.fromRange1.message = '';
            this.setState(state);
        }



        if (this.state.fromRange2 == "") {
            state.fromRange2.isValid = false;
            state.fromRange2.message = 'From Range is required';
            this.setState(state);
        }

        else {
            state.fromRange2.isValid = true;
            state.fromRange2.message = '';
            this.setState(state);
        }



        if (this.state.fromRange3 == "") {
            state.fromRange3.isValid = false;
            state.fromRange3.message = 'From Range is required';
            this.setState(state);
        }

        else {
            state.fromRange3.isValid = true;
            state.fromRange3.message = '';
            this.setState(state);
        }

        if (this.state.toRange1.message == '' && this.state.toRange2.message == '' && this.state.toRange3.message == '' && this.state.fromRange1.message == '' && this.state.fromRange2.message == '' && this.state.fromRange3.message == '') {

            let obj = {
                rangeV1: this.state.toRange1.value,
                rangeV2: this.state.fromRange1.value,
                rangeV3: this.state.toRange2.value,
                rangeV4: this.state.fromRange2.value,
                rangeV5: this.state.toRange3.value,
                rangeV6: this.state.fromRange3.value,
                country: this.state.country.value,
                countryAbb: this.state.countryAbbr

            }
            this.props.actions.addCurrencyFilter(obj);
        }
    }
    resetAll(){
       this.setState({
      
        toRange1: { value: '', IsValied: true, message: '' },
        toRange2: { value: '', IsValied: true, message: '' },
        toRange3: { value: '', IsValied: true, message: '' },
        fromRange1: { value: '', IsValied: true, message: '' },
        fromRange2: { value: '', IsValied: true, message: '' },
        fromRange3: { value: '', IsValied: true, message: '' },
 
       })
    }
    render() {

        return (

            <div className="content-wrapper">
                <section className="content container-fluid">
                					<ToastContainer />

                    <form>
                        <div className="marginauto">
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg email">
                                            <span className="input-group-addon">
                                                <SVGICONS.CountryNameSvg />
                                            </span>
                                            <select disabled={this.state.isDisable} className="form-control" style={{ border: 0 }} name="country" value={this.state.country.value} onChange={this.onCountryChange.bind(this)} >
                                                <option value="">Country</option>
                                                {this.state.countryList && this.state.countryList.length > 0 ? this.state.countryList.map((option, index) => <option value={option._id} key={index}>{option.name}</option>) : ''}
                                            </select>
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.country && this.state.country.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="toRange1" value={this.state.toRange1 ? this.state.toRange1.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter To-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.toRange1 && this.state.toRange1.message}</span>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="fromRange1" value={this.state.fromRange1 ? this.state.fromRange1.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter From-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.fromRange1 && this.state.fromRange1.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="toRange2" value={this.state.toRange2 ? this.state.toRange2.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter To-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.toRange2 && this.state.toRange2.message}</span>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="fromRange2" value={this.state.fromRange2 ? this.state.fromRange2.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter From-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.fromRange2 && this.state.fromRange2.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="toRange3" value={this.state.toRange3 ? this.state.toRange3.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter To-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.toRange3 && this.state.toRange3.message}</span>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                    <div className="boxMrgB">
                                        <div className="input-group inputBg">
                                            <span className="input-group-addon">
                                                <i className="fa ">
                                                    <img src={require('../../../../images/img/user_input_icon.svg')} alt="" />
                                                </i>
                                            </span>
                                            <input type="text" disabled={this.state.isDisable} name="fromRange3" value={this.state.fromRange3 ? this.state.fromRange3.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter From-Range" />
                                        </div>
                                        <span className="help-block" style={{ errorFontSize }}>{this.state.fromRange3 && this.state.fromRange3.message}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row m-t-30">
                            <div className="col-md-12 text-center">
                                <div className="toppad">
                                    <button type="button" className="btn btn-warning btn-lg pd-btn" data-toggle="modal" onClick={this.saveFlterData}
                                    //  disabled={this.state.disabled}
                                    >Save</button>  <button type="button" className="btn btn-cancel btn-default btn-lg p-d-rst" onClick={this.resetAll}>Reset</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <div className="Copyrightafterlogin">
                    <p>Medfix &copy; 2018. All rights reserved</p>
                </div>
            </div>

        );
    }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    // debugger
    return {
        countryList: state.specialist.countryList,
        currencyFilter: state.specialist.currencyFilter,
        listcurrencyFilter: state.specialist.listcurrencyFilter
    }
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(specialistActions, dispatch),


    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CurrencyDashboard);
